import { useEffect } from 'react';
import { skipToken } from '@reduxjs/toolkit/query';

import PageTitle from 'containers/page-title';
import PageLayout from 'layouts/PageLayout';
import useDispatch from 'shared/hooks/useDispatch';
import StyledFiltersBar from 'shared/components/styled/FiltersBar';

import { cooperativeCommonCasesApi } from '../../api';
import { cooperativeCommonCasesSlice } from '../../models';
import useGetCooperativeCommonCasesListRequestParameters from '../../lib/useGetCooperativeCommonCasesListRequestParameters';

import CooperativeCommonCasesGrid from '../CooperativeCommonCasesGrid';
import SearchBar from '../SearchBar';

const CooperativeCommonCasesPage = () => {
  const getCooperativeCommonCasesListRequestParameters =
    useGetCooperativeCommonCasesListRequestParameters();

  const dispatch = useDispatch();

  const { isLoading, isFetching, isError } =
    cooperativeCommonCasesApi.useGetCooperativeCommonCasesListQuery(
      getCooperativeCommonCasesListRequestParameters.cooperativeId
        ? {
            cooperativeId:
              getCooperativeCommonCasesListRequestParameters.cooperativeId,
            isConstructor:
              getCooperativeCommonCasesListRequestParameters.isConstructor,
          }
        : skipToken,
      {
        refetchOnMountOrArgChange: true,
      }
    );

  useEffect(() => {
    return () => {
      dispatch(cooperativeCommonCasesSlice.actions.reset());
    };
  }, []);

  return (
    <PageLayout isLoading={isLoading} isError={isError}>
      <PageTitle />
      <StyledFiltersBar
        direction={{
          xs: 'column',
          sm: 'row',
        }}
        justifyContent="flex-end"
        spacing={{
          xs: 2,
          md: 0,
        }}
      >
        <SearchBar />
      </StyledFiltersBar>
      <CooperativeCommonCasesGrid isFetching={isFetching} />
    </PageLayout>
  );
};

export default CooperativeCommonCasesPage;
